export default __webpack_public_path__ + "static/media/metalDetectorPolicy_grey.4eec8395.png";